import { DataprotectionNotificationDisplayModelFormGroup, PortalkonfigurationDisplayModel, PhaseDisplayModel } from "@/api/model-index";
import { I18nService } from "@/core/services/i18nService";
import { PortalContextService } from "@/core/services/portal-context.service";
import { HTML } from "@/core/utils/html";
import { Component, Input } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";

@Component({
  selector: 'dataprotection',
  templateUrl: './dataprotection.component.html',
  styleUrls: ['./dataprotection.component.scss']
})
export class DataprotectionComponent {
  @Input("form") public dataprotectionForm: DataprotectionNotificationDisplayModelFormGroup;
  @Input() portalkonfiguration: PortalkonfigurationDisplayModel;

  constructor(
    protected languageservice: I18nService,
    protected portalContextService: PortalContextService,
    ) { 
    
  }

  public get datenschutzFormControl(): AbstractControl {
    return this.dataprotectionForm?.controls["dsgvoAccepted"];
  }

  public get datenschutzErrorMessages(): string[] {
    let validationErrors: ValidationErrors | null = this.datenschutzFormControl.errors;

    if(!validationErrors)
      return [];

    return this.toDatenschutzErrorMessage(validationErrors);
  }


  public get currentPhase(): PhaseDisplayModel | undefined{
    return this.portalContextService.CurrentGutachten?.gutachtenPhase ?? this.portalContextService.CurrentAnfrage.phase;
  }


  /**
   * Wenn getTextsFromPhase true ist, dann werden die Datenschutzerklärungstexte aus der Phase genommen.
   * Ansonsten werden die Datenschutzerklärungstexte aus der Portalkonfiguration genommen.
   * Wenn beide nicht vorhanden sind, wird "undefinedText" zurückgegeben.
   * 
   * @returns string
   */
  public get dataprotectionText(): string | null | undefined {
    const text = this.languageservice.getCurrentLocalizedTextDisplayModel(this.currentPhase?.datenschutzerklaerungen)?.text ?? "";
    const trimmedText = HTML.trim(text);

    if (trimmedText)
      return text;

    return this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.datenschutzerklaerungen)?.text ?? this.languageservice.instant('undefinedText');
  }

  

  /**
   * Wenn getTextsFromPhase true ist, dann wird der Absendenüberschrift aus der Phase genommen.
   * Ansonsten wird der Absendenüberschrift aus der Portalkonfiguration genommen.
   * Wenn beide nicht vorhanden sind, wird "undefined" zurückgegeben.
   * 
   * @returns string | null | undefined
   */
  public get dataprotectionTitle() : string | null | undefined {
    const text = this.languageservice.getCurrentLocalizedTextDisplayModel(this.currentPhase?.absendenUeberschrift)?.text ?? "";
    const trimmedText = HTML.trim(text);

    if (trimmedText)
      return text;

    return this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.absendenUeberschrift)?.text ?? undefined;
  }

  /**
   * Wenn getTextsFromPhase true ist, dann wird der Absendenüberschrift aus der Phase genommen.
   * Ansonsten wird der Absendenüberschrift aus der Portalkonfiguration genommen.
   * Wenn beide nicht vorhanden sind, wird "undefined" zurückgegeben.
   * 
   * @returns string | null | undefined
   */
  public get dataprotectionInfoText(): string | null | undefined {
    const text = this.languageservice.getCurrentLocalizedTextDisplayModel(this.currentPhase?.absendenEinwilligungserklaerung)?.text ?? "";
    const trimmedText = HTML.trim(text);

    if (trimmedText)
      return text;
    
    return this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.absendenEinwilligungserklaerung)?.text ?? undefined;
  }


  protected toDatenschutzErrorMessage(validationErrors: ValidationErrors) : string[] {
    let errorMessages: string[] = [];

    for(let key in validationErrors){
      switch(key){
        case "required":
          errorMessages.push(this.languageservice.instant('register.privacypolicy_required'));
          break;
        default:
          errorMessages.push(this.languageservice.instant('register.invalid'));
      }
    }

    return errorMessages;
  }
}
